import { type FC, type ReactNode, type MouseEventHandler } from "react";
import styles from "./ScryShell.module.css";

export const ScryOrb: FC = () => (
  <svg viewBox="0 0 100 100" width="64" height="64" aria-hidden="true">
    <circle fill="currentColor" cx="50" cy="48" r="30" />
    <path
      d="M31,39 A23,23 0 0 1 45,25"
      stroke="var(--scry-paper, #f4efe2)"
      strokeWidth="5"
      strokeLinecap="round"
      fill="none"
    />
    <path
      fill="currentColor"
      d="M35,76 L65,76 L72,90 L28,90 Z M13,14 l2.5,6.5 6.5,2.5 -6.5,2.5 -2.5,6.5 -2.5,-6.5 -6.5,-2.5 6.5,-2.5 Z M86,30 l2,5 5,2 -5,2 -2,5 -2,-5 -5,-2 5,-2 Z"
    />
    <circle fill="currentColor" cx="79" cy="12" r="2.5" />
  </svg>
);

export const ScryWordmark: FC<{
  onHomeClick?: MouseEventHandler<HTMLAnchorElement>;
}> = ({ onHomeClick }) => (
  <span className={styles.brand}>
    <a href="/" onClick={onHomeClick} aria-label="Scry home">
      <ScryOrb />
      <span>scry</span>
    </a>
    <span aria-hidden="true">.</span>
    <a href="https://wzrdz.cool" target="_blank" rel="noreferrer">
      wzrdz.cool
    </a>
  </span>
);

export const ScryShell: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={styles.shell}>
    <header className={styles.header}>
      <ScryWordmark />
    </header>
    <main className={styles.main}>{children}</main>
    <footer className={styles.footer}>
      A little face time across the aether.
      <br />
      <span>
        Powered by Element Call · <a href="/scry-source.tar.gz">Source code</a>
      </span>
    </footer>
  </div>
);
